export default {
  placeholder: 'Caută afacere...',
};
